import { render, staticRenderFns } from "./supportUsList.vue?vue&type=template&id=29cb9e50&"
import script from "./supportUsList.vue?vue&type=script&lang=js&"
export * from "./supportUsList.vue?vue&type=script&lang=js&"
import style0 from "./supportUsList.vue?vue&type=style&index=0&id=29cb9e50&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports